/**
 * Data hardcodeada para el menú
 * Se está pasando a un approach más estático, desestimando Strapi/CMS
 */
export const hardcodedMenuItem = {
  id: 321321,
  attributes: {
    title: "Data Science",
    slogan: "Ciencia de Datos",
    href: "/soluciones/data",
    description: "Arquitecturas de datos para análisis unificado, consultas complejas y resultados escalables.",
    links: [
      {
        href: "data",
        title: "Data Science",
      },
    ],
    image: {
      data: {
        attributes: {
          url: "https://via.placeholder.com/150",
        },
      },
    },
  },
};

/**
 * Función helper para agregar un item a una opción específica del menú
 * @param {Array} options - Array de opciones del menú
 * @param {Object} config - Configuración para determinar dónde agregar el item
 * @param {number} [config.targetIndex] - Índice de la opción donde agregar el item (default: 0)
 * @param {string|number} [config.targetOptionId] - ID de la opción donde agregar el item (alternativa a targetIndex)
 * @param {Object} [config.itemToAdd] - Item a agregar (default: hardcodedMenuItem)
 * @returns {Array} - Array de opciones con el item agregado a la opción especificada
 */
export const addItemToMenuOption = (options, config = {}) => {
  if (!options?.length) {
    return [];
  }

  const {
    targetIndex = 0,
    targetOptionId = null,
    itemToAdd = hardcodedMenuItem,
  } = config;

  return options.map((option, index) => {
    // Determinar si esta es la opción objetivo
    const isTargetOption = typeof targetOptionId === 'string' || typeof targetOptionId === 'number'
      ? option.id === targetOptionId
      : index === targetIndex;

    if (isTargetOption && option.multipleOptions?.data) {
      return {
        ...option,
        multipleOptions: {
          ...option.multipleOptions,
          data: [...option.multipleOptions.data, itemToAdd],
        },
      };
    }
    return option;
  });
};

